// pages/incident/IncidentCreate.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Button, Flex, Input, Select, Spin, message } from "antd"; // ✅ ADD message
import { useCreateIncidentMutation } from "./incident.service";
import { useFetchTeamMembersQuery } from "../team/team.service";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LocationSelector from "../../components/LocationSelector";
import "./style.css";

export default function IncidentCreate() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.user);

  // ✅ Location state
  const [locationId, setLocationId] = useState(null);

  const [form] = Form.useForm();

  // ✅ Set initial location from user
  useEffect(() => {
    const locId = user?.activeLocationId || user?.restaurantId;
    setLocationId(locId);
  }, [user]);

  // ✅ Handle location change
  const handleLocationChange = (newLocationId) => {
    setLocationId(newLocationId);
  };

  // ✅ Fetch team members with location
  const { 
    data = { data: { members: [] } }, 
    isLoading: isTeamLoading,
    refetch: refetchTeam 
  } = useFetchTeamMembersQuery(locationId, {
    refetchOnMountOrArgChange: true,
    skip: !locationId,
  });

  const {
    data: { members },
  } = data;

  const [requestCreateIncident, { isSuccess, isLoading }] =
    useCreateIncidentMutation();

  useEffect(() => {
    if (isSuccess) {
      form.resetFields();
      message.success(t("Incident created successfully!")); // ✅ Success message bhi add kar do
    }
  }, [isSuccess]);

  const handleFormSubmit = (e) => {
    if (!locationId) {
      message.error("Please select a location first");
      return;
    }
    requestCreateIncident(e);
  };

  return (
    <Spin spinning={isTeamLoading}>
      <Card
        className="incident-page"
        bordered={false}
        title={
          <Flex align="center" gap="middle" wrap>
            <span>{`${t("Incident")} ${t("Create")}`}</span>
            {/* ✅ Add LocationSelector */}
            <LocationSelector onLocationChange={handleLocationChange} />
          </Flex>
        }
        extra={
          <Button onClick={() => navigate("/incidents")}>{t("BACK")}</Button>
        }
      >
        <div className="incident-page-container">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleFormSubmit}
            initialValues={{
              incident: "",
              resolution: "",
              nameofemployee: "",
            }}
          >
            <div>{t("INCIDENT")}</div>
            <Form.Item
              name="incident"
              rules={[
                {
                  required: true,
                  message: "Please enter an incident",
                },
              ]}
            >
              <Input.TextArea rows={3} />
            </Form.Item>
            <div>{t("RESOLUTION")}</div>
            <Form.Item name="resolution">
              <Input.TextArea rows={3} />
            </Form.Item>
            <div>{t("NAME OF EMPLOYEE")}</div>
            <Form.Item
              name="employeeName"
              rules={[
                {
                  required: true,
                  message: "Please enter an name of employee",
                },
              ]}
            >
              <Select
                loading={isTeamLoading}
                options={members.reduce((arr, cur) => {
                  arr.push({ value: cur.name, label: cur.name });
                  return arr;
                }, [])}
                placeholder={locationId ? t("Select employee") : t("Please select a location first")}
                disabled={!locationId}
              />
            </Form.Item>
            <Flex justify="center">
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={isLoading}
                disabled={!locationId}
              >
                {t("Submit")}
              </Button>
            </Flex>
          </Form>
        </div>
      </Card>
    </Spin>
  );
}